module.exports = __webpack_public_path__ + "img/complete_course.8fc67532.png";